import { Length, ModelBase, Pattern, Property, Required, ShortLength, VeryLongLength, VeryShortLength } from '@skylab-shared/core';
import { OrderRecipientKind } from './common/order-recipient-kind';
import { OrderRecipientAddressModel } from './order-recipient-address.model';
import { OrdersValidationPatterns } from './order-violation-patterns';

export class OrderRecipientModel extends ModelBase {
	@Property()
	public kind: OrderRecipientKind;

	@Property(OrderRecipientAddressModel, {nullable: true})
	public address: OrderRecipientAddressModel | null;

	@Property()
	@Pattern({pattern: OrdersValidationPatterns.Name}, 'data-model.orders.recipient.validation.last-name.pattern')
	@Length({ max: ShortLength }, 'data-model.orders.recipient.validation.last-name.length')
	public lastName: string;

	@Property()
	@Pattern({pattern: OrdersValidationPatterns.Name}, 'data-model.orders.recipient.validation.first-name.pattern')
	@Length({ max: ShortLength }, 'data-model.orders.recipient.validation.first-name.length')
	public firstName: string;

	@Property()
	@Length({ max: VeryShortLength }, 'data-model.orders.recipient.validation.phone.length')
	@Pattern({pattern: OrdersValidationPatterns.Phone}, 'data-model.orders.recipient.validation.phone.pattern')
	@Required('data-model.orders.recipient.validation.phone.required')
	public phoneNumber: string;

	@Property({nullable: true})
	@Required('data-model.orders.recipient.validation.email.required')
	@Length({max: 255}, 'data-model.orders.recipient.validation.email.length')
	@Pattern({ pattern: OrdersValidationPatterns.Email}, 'data-model.orders.recipient.validation.email.pattern')
	public email: string

	@Property()
	@Length({ max: VeryLongLength }, 'data-model.orders.recipient.validation.company-name.length')
	public companyName: string

	@Property()
	@Length({ max: VeryShortLength }, 'data-model.orders.recipient.validation.tax-identification.length')
	public taxIdentification: string
}
